import { EndOfContractExerciseOfPurchaseOptionDetails } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { Reducer } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const endOfContractExerciseOfPurchaseOptionInitialState = {
    results: {} as { [id: string]: ApiRequest<EndOfContractExerciseOfPurchaseOptionDetails> },
} as const;

type DocumentAccountExtractState = typeof endOfContractExerciseOfPurchaseOptionInitialState;

export const EndOfContractExerciseOfPurchaseOptionReducer: Reducer<DocumentAccountExtractState> = (state = endOfContractExerciseOfPurchaseOptionInitialState, action) => {
    switch (action.type) {

        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EXERCISE_OF_PURCHASE_OPTION/GET':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: true,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EXERCISE_OF_PURCHASE_OPTION/GET_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: false,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/END_OF_CONTRACT/EXERCISE_OF_PURCHASE_OPTION/GET_FAILURE':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/INSTRUCTION/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/NON_COMPLIANCE/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        default:
            return state;

    }
};